<template>
  <KTPortlet title="Профиль">
    <div slot="body">
      <v-form ref="form" v-model="valid" :lazy-validation="false">
        <v-autocomplete
          v-model="form.city_id"
          :items="cities"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          label="Ваш город"
          placeholder="Выбрать город"
          :rules="cityRules"
        ></v-autocomplete>
        <v-text-field v-model="form.name" type="text" :rules="nameRules" label="Ваше Имя" required></v-text-field>
        <v-text-field v-model="form.email" type="text" :rules="emailRules" label="E-mail" required></v-text-field>
        <v-text-field
          v-model="form.password"
          type="password"
          :rules="passwordRules"
          label="Пароль"
          required
        ></v-text-field>
        <div class="d-flex align-center justify-space-between mt-5">
          <router-link :to="{name: 'login'}">Назад</router-link>
          <v-btn color="primary" @click="onSubmit" :loading="submitting">Сохранить</v-btn>
        </div>
      </v-form>
    </div>
  </KTPortlet>
</template>

<script>
import KTPortlet from "@/view/content/Card.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "register",
  components: { KTPortlet },
  data() {
    return {
      cities: [],
      valid: true,
      loading: false,
      form: {
        name: "",
        email: "",
        city_id: "",
        password: ""
      },
      cityRules: [v => !!v || "не может быть пустым"],
      nameRules: [v => !!v || "не может быть пустым"],
      emailRules: [
        v => !v || /.+@.+\..+/.test(v) || 'некорректный адрес',
      ],
      passwordRules: [
        v =>
          !v ||
          v.length == 0 ||
          v.length >= 8 ||
          "минимальная длина пароля 8 символов"
      ],
      submitting: false
    };
  },
  beforeMount() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Профиль" }]);
    this.$api.cities.select().then(response => {
      this.cities = response.data.items;
    });
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$api.profile
        .get()
        .then(response => {
          this.form = {
            email: response.data.email,
            name: response.data.name,
            city_id: response.data.city.id,
            password: null,
            password_confirmation: null
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.$api.profile
          .update({
            email: this.form.email,
            password: this.form.password,
            name: this.form.name,
            city_id: this.form.city_id
          })
          .then(() => {
            this.$toast.success("Операция выполнена.");

            this.fetchData();
          })
          .catch(error => {
            this.$toast.error(error.response.data.errors.base.join(", "), {
              icon: "fa-exclamation-circle"
            });
          })
          .finally(() => {
            this.submitting = false;
          });
      }
    }
  }
};
</script>
